/**
 * This code was AUTOGENERATED using the Codama library.
 * Please DO NOT EDIT THIS FILE, instead use visitors
 * to add features, then rerun Codama to update it.
 *
 * @see https://github.com/codama-idl/codama
 */

import {
  getAddressEncoder,
  getProgramDerivedAddress,
  getUtf8Encoder,
  type Address,
  type ProgramDerivedAddress,
} from "@solana/kit";

export type PoolSeeds = {
  /** The config account address */
  config: Address;
  /** The first token mint (sorted) */
  tokenAMint: Address;
  /** The second token mint (sorted) */
  tokenBMint: Address;
};

/**
 * A liquidity pool account for a specific token pair under a given config.
 * Token mints must be sorted - tokenAMint should be lexicographically smaller than tokenBMint.
 */
export async function findPoolPda(
  seeds: PoolSeeds,
  config: { programAddress?: Address | undefined } = {},
): Promise<ProgramDerivedAddress> {
  const {
    programAddress = "cpamdpZCGKUy5JxQXB4dcpGPiikHawvSWAd6mEn1sGG" as Address<"cpamdpZCGKUy5JxQXB4dcpGPiikHawvSWAd6mEn1sGG">,
  } = config;
  return await getProgramDerivedAddress({
    programAddress,
    seeds: [
      getUtf8Encoder().encode("pool"),
      getAddressEncoder().encode(seeds.config),
      getAddressEncoder().encode(seeds.tokenAMint),
      getAddressEncoder().encode(seeds.tokenBMint),
    ],
  });
}
